<template>
  <div class="header-search-wrap">
    <div class="header-search">
      <form class="search-form" @submit.prevent="search">
        <div class="header-search-lg">
          <input
            type="text"
            name="query"
            class="form-control search-input"
            v-model="searchText"
            :placeholder="placeholder"
          />

          <div class="header-search-right">
            <button type="submit" class="btn btn-search p-4">
              <i class="las la-search"></i>
              <span v-show="showButtonText" class="ml-2">Search</span>
            </button>
          </div>
        </div>

        <!-- REVIEW: hide the header-search-sm -->
        <div v-show="false" class="header-search-sm">
          <i class="las la-search"></i>
        </div>
      </form>
    </div>

    <!-- REVIEW: hide the header-search-sm-from -->
    <div v-show="false" class="header-search-sm-form">
      <form class="search-form" @submit.prevent="search">
        <div class="btn-close">
          <i class="las la-arrow-left"></i>
        </div>

        <!-- Cannot use v-model due to a bug. See https://github.com/vuejs/vue/issues/8231 -->
        <input
          type="text"
          name="query"
          class="form-control search-input-sm"
          :value="searchText"
          @input="searchText = $event.target.value"
        />

        <button type="submit" class="btn btn-search">
          <i class="las la-search"></i>
        </button>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    placeholder: { type: String, required: false, default: '' },
    showButtonText: { type: Boolean, required: false, default: true }
  },
  data() {
    return { searchText: '' }
  },
  methods: {
    search() {
      this.$emit('search', this.searchText)
    }
  }
}
</script>

<style lang="scss" scoped>
.header-search .header-search-lg .search-input {
  color: black !important;
}

.header-search-wrap {
  position: relative;
  min-width: 0;
  flex-grow: 1;
  padding: 0 40px;
}

.search-input::placeholder {
  color: #000 !important;
  opacity: 1;
}

.search-input::-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #000;
}

.search-input::-ms-input-placeholder {
  /* Microsoft Edge */
  color: #000;
}

.header-search {
  position: relative;
  width: 100%;

  .header-search-lg {
    position: relative;
    display: flex;
    border: 1px solid var(--border-color);
    border-radius: var(--radius-new);

    .search-input {
      height: 58px;
      padding-left: 30px;
      border: none;
      border-radius: 25px;
      background: transparent;
      color: #fff;
    }

    .header-search-right {
      display: flex;
      align-items: center;
      margin-right: 4px;
    }

    .btn-search {
      display: flex;
      height: 50px;
      width: fit-content;
      padding: 0;
      align-items: center;
      justify-content: center;
      border-radius: var(--radius-new);
      color: var(--color-white);
      background: var(--color-black);

      > i {
        font-size: 18px;
        line-height: 36px;
      }
    }
  }

  .nice-select {
    display: flex;
    align-items: center;

    .list {
      margin-top: 19px;
    }
  }
}

.header-search-sm-form {
  position: absolute;
  left: 15px;
  right: 15px;
  top: 0;
  height: 100%;
  background: var(--color-white);
  opacity: 0;
  z-index: -1;
  transform: scale(0.96);
  pointer-events: none;
  transition: var(--transition-default);

  &.active {
    opacity: 1;
    transform: scale(1);
    z-index: 1;
    pointer-events: auto;
  }

  > form {
    position: relative;
    display: flex;
    width: 100%;
    align-items: center;

    > input {
      height: 60px;
      padding: 10px 50px;
      border: none;
    }

    .btn-close,
    .btn-search {
      position: absolute;
      top: 50%;
      display: flex;
      height: 50px;
      width: 50px;
      padding: 15px;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      transform: translateY(-50%);

      &:hover {
        > i {
          color: var(--color-default);
        }
      }

      > i {
        font-size: 24px;
        color: var(--color-gray);
        transition: var(--transition-default);
      }
    }

    .btn-close {
      left: 0;
    }

    .btn-search {
      right: 0;
    }
  }
}

@media screen and (min-width: 992px) {
  .header-search {
    .header-search-sm {
      display: none;
    }
  }

  .header-search-sm-form {
    display: none;
  }
}

@media screen and (max-width: var(--lg)) {
  .header-search-wrap {
    position: static;
    display: flex;
    justify-content: center;
    flex-grow: 0;
    margin-left: auto;
    padding: 0 15px;
    align-items: center;
  }

  .header-search {
    .header-search-lg {
      display: none;
    }

    .header-search-sm {
      &:hover {
        > i {
          color: var(--color-default);
        }
      }

      > i {
        font-size: 34px;
        line-height: 36px;
        color: var(--color-black);
        cursor: pointer;
        transition: var(--transition-default);
      }
    }
  }
}

@media screen and (max-width: 391px) {
  .header-search-wrap {
    padding: 0 10px;
  }
}

li {
  .bottom-line {
    border-bottom: 1px solid #dddddd;
  }
}
</style>
